import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {VetClinic, VetDoctor, VImage} from "../../models/vet-clinic.model";
import {Subscription} from "rxjs";
import {VetClinicInfoData} from "../../models/vet-clinic-info-data.model";
import {User} from "../../models/user.model";
import {Client} from "../../models/client.model";
import {VisitType} from "../../models/vet-clinic-data.model";
import {AppStateService} from "../../providers/app-state.service";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {CommonUtils} from "../../utils/common";
import {FileService} from "../../providers/file.service";
import {ModalController} from "@ionic/angular";
import {UserService} from "../../providers/user.service";

@Component({
  selector: 'app-clinic-team-edit',
  templateUrl: './clinic-team-edit.component.html',
  styleUrls: ['./clinic-team-edit.component.scss'],
})
export class ClinicTeamEditComponent implements OnInit {

  @Input()
  vetClinic: VetClinic;
  isBusySub: Subscription;
  userSub: Subscription;

  @Output()
  vetClinicEditedEmitter: EventEmitter<VetClinic> = new EventEmitter<VetClinic>();
  @Output()
  cancelVetClinicEditedEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  hasUnsavedChangesEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  vetClinicGroup: FormGroup;
  vetDoctorToEdit: VetDoctor;
  vetClinicInfoData: VetClinicInfoData;
  servicesItems: string[];
  services: string[];
  vImages: VImage[];
  vImagesSub: Subscription;
  hasUnsavedChanges: boolean = false;
  isAdmin: boolean;
  isGeneralAdmin: boolean;
  isGeneralClientAdmin: boolean;
  loggedUser: User;
  partners: Client[];
  partner: Client;
  images: VImage[];
  vc: VetClinic;
  linkedReservationDoctors: VetDoctor[];

  selectedGVisitType: any;
  vTypes: VisitType[] = [];
  isBusy: boolean;
  onlineVisitBlockChangeNames: string[] = [];

  constructor(private appStateService: AppStateService, private vetClinicService: VetClinicService, private userService: UserService
    , private commonUtils: CommonUtils, private fileService: FileService, private modalController: ModalController) {
  }

  buildTeamData() {
    if (this.vetClinic?.team) {
      this.vetClinic.team.sort((t1, t2) => {
        if (t1.orderIndex !== undefined && t2.orderIndex !== undefined) {
          if (t1.orderIndex > t2.orderIndex) {
            return 1;
          } else if (t1.orderIndex < t2.orderIndex) {
            return -1;
          } else {
            return 0;
          }
        } else {
          return 0;
        }
      })
    }
  }

  ngOnInit() {
    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
      if (isBusy) {
        if (this.vetClinicGroup) {
          this.vetClinicGroup.disable();
        }
      } else {
        if (this.vetClinicGroup) {
          this.vetClinicGroup.enable();
        }
      }
    });

    this.userSub = this.userService.getUser().subscribe(it => {
        this.loggedUser = this.commonUtils.bestTypedCopyEver<User>(new User(), it);
        this.isAdmin = this.loggedUser.roles.split(';').filter(e => e === 'admin').length === 1;
        this.isGeneralAdmin = this.isAdmin && this.loggedUser.vClientId === null && this.loggedUser.vetcodeId === null;
        this.isGeneralClientAdmin = this.loggedUser.roles.split(';').filter(e => e === 'clients').length === 1 && this.loggedUser.vClientId === null && this.loggedUser.vetcodeId === null;
      }
    );

    this.buildTeamData();

    this.appStateService.updateIsBusySubject(true)
    this.partner = this.partners?.filter(e => e.id === this.vetClinic?.partnerVClientId)[0];
    this.vTypes = this.vetClinic.visitTypes;
    this.selectedGVisitType = 'all-types';
    this.vetClinic.visitTypes.forEach(visitType => {
      let vetVisitType = this.vetClinic?.vetVisitTypes?.filter(e => e.klinikaXpVisitId === visitType.xid)[0];
      if (vetVisitType === undefined) {
        return visitType;
      } else {
        visitType.prepaidPrice = vetVisitType?.prepaidPrice
        visitType.online = vetVisitType?.online
        visitType.prepaidRequired = vetVisitType?.prepaidRequired
        return visitType
      }
    })
    this.linkedReservationDoctors = this.vetClinic.team?.filter(e => e.hasLinkedReservation);

    if (this.vetClinic?.services) {
      this.services = JSON.parse(this.vetClinic.services);
      this.servicesItems = JSON.parse(this.vetClinic.services);
    }
    this.vImagesSub = this.fileService.getVImages(false, this.vetClinic?.vetcodeId.toString()).subscribe(images => {
      this.vImages = images;
    });

    this.vc = JSON.parse(JSON.stringify(this.vetClinic));
    this.appStateService.updateIsBusySubject(false);
  }


  onVetDoctorEditCanceled(cancel: Boolean) {
    if (cancel) {
      this.vetDoctorToEdit = null;
    }
  }


  listPotentialAvailableDoctorToLinkVisits(): VetDoctor[] {
    if (this.linkedReservationDoctors && this.linkedReservationDoctors.length > 0) {
      let vetDoctor = this.linkedReservationDoctors[0];

      if (this.vetClinic.useVetineoVetVisitTypes && vetDoctor.defaultVisitMinutes){
        if (vetDoctor.hasLinkedReservation && vetDoctor.defaultVisitMinutes) {
          return this.vetClinic.team.filter(e => !e.hasLinkedReservation).filter(s => s.defaultVisitMinutes === vetDoctor.defaultVisitMinutes)
        } else {
          return null;
        }
      } else {
        if (vetDoctor.hasLinkedReservation && vetDoctor.stdVisitMinutes) {
          return this.vetClinic.team.filter(e => !e.hasLinkedReservation).filter(s => s.stdVisitMinutes === vetDoctor.stdVisitMinutes)
        } else {
          return null;
        }
      }

    } else {
      return this.vetClinic.team;
    }
  }

  onAddToList(vDoc: VetDoctor) {
    vDoc.hasLinkedReservation = true;
    this.vetClinic.team = this.vetClinic.team.map(e => {
        if (e.uuid === vDoc.uuid) {
          e.hasLinkedReservation = true;
        }
        return e;
      }
    )
    this.linkedReservationDoctors.push(vDoc);
    this.markUnsavedChanges();
  }

  getTeam() {
    return this.vetClinic?.team.sort((a, b) => a.orderIndex - b.orderIndex)
  }

  onRemoveFromList(doc: VetDoctor) {
    doc.hasLinkedReservation = false;
    this.vetClinic.team = this.vetClinic.team.map(e => {
        if (e.uuid === doc.uuid) {
          e.hasLinkedReservation = false;
        }
        return e;
      }
    )
    this.linkedReservationDoctors = this.linkedReservationDoctors.filter(e => e.uuid !== doc.uuid);
    this.markUnsavedChanges();
  }

  onCancelEdit() {
    if (this.images && this.images.length > 0) {
      console.log(this.images);
      this.markUnsavedChanges();
    }
    if (this.hasUnsavedChanges) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany, czy na pewno chcesz zrezygnować z zapisania zmian w zespole?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.cancelVetClinicEditedEmitter.emit(true)
        this.hasUnsavedChanges = false;
      }, () => {
      });
    } else {
      this.commonUtils.presentYesNoActionSheet('Czy na pewno chcesz zrezygnować z edycji zespołu?', 'Tak', 'Nie', 'checkmark-outline', 'close', () => {
        this.cancelVetClinicEditedEmitter.emit(true)
        this.hasUnsavedChanges = false;
      }, () => {
      });
    }
  }

  private markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChangesEmitter.emit(true);
      this.hasUnsavedChanges = true;
    }
  }

  onEditDoctor(vetDoctor: VetDoctor) {
    console.log('onEditDoctor');
    this.appStateService.updateIsBusySubject(true);
    this.vetClinicService.getSpecificVetClinic(this.vetClinic.uuid).subscribe(e => {
      this.vetClinic = e;
      this.vetDoctorToEdit = null
      this.appStateService.updateIsBusySubject(false);
    }, error => {
      this.appStateService.updateIsBusySubject(false);
    });
    this.markUnsavedChanges();
  }

  onSave() {
    let txt = 'Na pewno chcesz zapisać zmiany?';

    if (this.onlineVisitBlockChangeNames.length >= 1) {
      let str = 'Dla następujących pracowników blokady rezerwacji online zostały zmienione: ';
      this.onlineVisitBlockChangeNames.forEach(name => {
        str = `${str} ${name},`;
      });
      str = `${str} czy chcesz zapisać i zastosować te zmiany?`;
      txt = str;
    }
    this.vetClinic.team?.forEach((vetDoctor, index) => {
      vetDoctor.orderIndex = index;
    });

    this.commonUtils.presentYesNoActionSheet(txt, 'Tak', 'Nie', 'checkmark-outline', 'close', () => {
      this.appStateService.updateIsBusySubject(true);
      this.vetClinic.servicesJson = JSON.stringify(this.servicesItems);

      this.vetClinicService.updateVetClinic(this.vetClinic, false)
        .subscribe((vc: VetClinic) => {
            this.commonUtils.presentInfoToast("Dane lecznicy zostały zmienione").then(res => {
            });
            this.hasUnsavedChanges = false;
            this.vetClinic = null;
            this.partner = null;
            this.vetClinicEditedEmitter.emit(vc);
            this.appStateService.updateIsBusySubject(false);
          },
          error => {
            this.appStateService.updateIsBusySubject(false);
            this.commonUtils.presentAlertToast("Wystąpił błąd podczas zmiany danych lecznicy");
          });
    }, () => {
    });

  }

  synchronizeSitesbiDoctors() {
    if (this.isGeneralAdmin || this.isGeneralClientAdmin) {
      this.commonUtils.presentYesNoActionSheet('Na pewno chcesz dokonać synchronizacji pracowników? Dane o kolejności, rez. progresywnych itp. będą nadpisane.', 'Tak', 'Nie', 'cloud-download-outline', 'close', () => {
        this.appStateService.updateIsBusySubject(true);
        this.vetClinicService.syncSitesbiVetDoctorData(this.vetClinic?.vetcodeId).subscribe(async res => {
          await this.commonUtils.presentInfoToast('Synchronizacja przebiegła prawidłowo');
          this.fetchClinicToEdit(this.vetClinic.uuid);
          this.appStateService.updateIsBusySubject(false);
        }, async error => {
          await this.commonUtils.presentAlertToast('Nie udało się zsynchronizować pracowników z Sitesbi');
          this.appStateService.updateIsBusySubject(false);
        });
      }, () => {
      });
      this.markUnsavedChanges();
    }
  }

  synchronizeVetDoctors() {
    if (this.isGeneralAdmin || this.isGeneralClientAdmin) {
      this.commonUtils.presentYesNoActionSheet('Na pewno chcesz dokonać synchronizacji pracowników z bazą KXP, utracisz wszystkie niezapisane zmiany?', 'Tak', 'Nie', 'cloud-download-outline', 'close', () => {
        this.appStateService.updateIsBusySubject(true);
        this.vetClinicService.syncVetDoctorData(this.vetClinic?.vetcodeId).subscribe(async res => {
          await this.commonUtils.presentInfoToast('Synchronizacja przebiegła prawidłowo');
          this.fetchClinicToEdit(this.vetClinic.uuid);
          this.appStateService.updateIsBusySubject(false);
        }, async error => {
          await this.commonUtils.presentAlertToast('Nie udało się zsynchronizować pracowników z bazą KXP');
          this.appStateService.updateIsBusySubject(false);
        });
      }, () => {
      });
      this.markUnsavedChanges();
    }
  }

  fetchClinicToEdit(uuid, showEditInfo = true) {
    this.appStateService.updateIsBusySubject(true);
    this.vetClinicService.getSpecificVetClinic(uuid).subscribe(e => {
      this.vetClinic = e;
      this.buildTeamData();
      if (showEditInfo) {
        this.commonUtils.presentInfoToast('Informacje o zespole zostały załadowane ponownie');
      }
      this.appStateService.updateIsBusySubject(false);
    }, error => {
      this.appStateService.updateIsBusySubject(false);
    });
  }

  onChangeOnlineReservationBlock(name: string) {
    if (!this.onlineVisitBlockChangeNames.includes(name)) {
      this.onlineVisitBlockChangeNames.push(name)
    }
  }

  onDoctorDeleted() {
    this.commonUtils.presentInfoToast('Pracownik został pomyślnie usunięty z Vetineo');
    this.fetchClinicToEdit(this.vetClinic.uuid, false);
    this.vetDoctorToEdit = null;
  }

  getDefaultVisitMinutes(vetDoctor: any) {
    if (vetDoctor.defaultVisitMinutes) {
      return vetDoctor.defaultVisitMinutes;
    } else {
      return '-';
    }
  }
}


